export type DialogPropsBase = { destroy: () => void };
export type DialogProps<PROPS> = DialogPropsBase & PROPS;

export const NO_RESULT = Symbol('NO_RESULT');

export type DialogResult<RESULT> = RESULT | typeof NO_RESULT;

export type CloseDialogFn<RESULT> = (result?: DialogResult<RESULT>) => void;
